<script type="ts">
  import type { Dropdown, TemplateOneItems } from "../lib/interfaces";
  import { fade } from "svelte/transition";

  export let dropdown: Dropdown;

  const fadeParams = {
    duration: 250
  };
  const items : Array<TemplateOneItems> = dropdown.template_1.items;

</script>

<div in:fade out:fade class="dropdown-one">
  <div class="dropdown-one__wrapper">

    {#each items as item}

      <a transition:fade={fadeParams} class="dropdown-one__item" href={item.link.url}>
        <img class="dropdown-one__image" src={item.icon} alt="{item.link.title}" />
        <div class="dropdown-one__content">
          <span class="dropdown-one__title">{item.link.title}</span>
          <span class="dropdown-one__excerpt">{item.excerpt}</span>
        </div>
      </a>

    {/each}

  </div>
</div>

